exports = module.exports = require("../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".anchor-anchor-2IWMqhvymwr{cursor:pointer;text-decoration:inherit;color:inherit}\n", ""]);
// Exports
exports.locals = {
	"anchor": "anchor-anchor-2IWMqhvymwr"
};